const spacing = {
	spacing: (factor: number) => `${0.25 * factor}rem`
};

export default spacing;
